import { Button, Drawer, Flex, Stack } from "@mantine/core";

import { TextWrapper } from "@/components/TextWrapper";

export interface ProcedureInformationDrawerProps {
  opened: boolean;
  onClose: () => void;
  title?: string;
  description?: string;
}

export default function ProcedureInformationDrawer({
  opened,
  onClose,
  title,
  description,
}: ProcedureInformationDrawerProps) {
  return (
    <Drawer.Root
      trapFocus
      size={500}
      opened={opened}
      position="right"
      onClose={onClose}
      closeOnEscape={false}
      closeOnClickOutside={false}
    >
      <Drawer.Overlay />
      <Drawer.Content bg="white">
        <Drawer.Header h={64} px="md" bg="gray.0">
          <Flex w="100%" gap="md" align="center" justify="space-between">
            <Flex gap="md" align="center" style={{ flex: 1 }}>
              <Drawer.CloseButton aria-label="Close Information Drawer" />
              <Drawer.Title style={{ flex: 1 }}>
                <TextWrapper fz="lg" c="dark.9" variant="bold">
                  Information
                </TextWrapper>
              </Drawer.Title>
            </Flex>
            <Button onClick={onClose}>Done</Button>
          </Flex>
        </Drawer.Header>
        <Drawer.Body p={24}>
          <Stack gap={24} align="center">
            {title && (
              <TextWrapper w="100%" c="gray.6" variant="bold">
                {title}
              </TextWrapper>
            )}
            {description && (
              <TextWrapper w="100%" c="dark.9">
                {description}
              </TextWrapper>
            )}
          </Stack>
        </Drawer.Body>
      </Drawer.Content>
    </Drawer.Root>
  );
}
